import api from './api';
import { API_PREFIX } from '../config';

export const analyticsService = {
  async getCardAnalytics(cardId) {
    const response = await api.get(`${API_PREFIX}/analytics/card/${cardId}`);
    return response.data;
  },

  async getMyCardsAnalytics() {
    const response = await api.get(`${API_PREFIX}/analytics/my-cards`);
    return response.data;
  },
};
